import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import channelInfoFragment from '../../fragments/channel/channelInfo';
import { getCommunityChannelConnectionQuery } from '../../queries/community/getCommunityChannelConnection';
import { getCommunityChannelConnectionSlackSettingsQuery } from '../../queries/community/getCommunityChannelsSlackSettings';

export const createChannelMutation = gql`
  mutation createChannel($input: CreateChannelInput!) {
    createChannel(input: $input) {
      ...channelInfo
    }
  }
  ${channelInfoFragment}
`;

const createChannelOptions = {
  props: ({ mutate }) => ({
    createChannel: input =>
      mutate({
        variables: {
          input,
        },
        refetchQueries: [
          {
            query: getCommunityChannelConnectionQuery,
            variables: {
              id: input.communityId,
            },
          },
          {
            query: getCommunityChannelConnectionSlackSettingsQuery,
            variables: {
              id: input.communityId,
            },
          },
        ],
      }),
  }),
};

export default graphql(createChannelMutation, createChannelOptions);
